import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const errors: ValidationErrors = {};

    // Check that length is at least 6 characters
    if (value.length < 6) {
      errors.passwordLength = true;
      return errors;
    }

    // Check that password is not whitespace-only
    if (!/\S/.test(value)) {
      errors.passwordWhitespace = true;
      return errors;
    }

    return null;
  };
}

/**
 * Cross-field validator that flags a mismatch between the `password` and
 * `confirmPassword` controls of a form group. The error is set on the group
 * (`passwordsMismatch`) so it reactively reflects the current values and ties
 * into the group's validity instead of being checked only at submit time.
 */
export function passwordsMatchValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordsMismatch: true };
  };
}
